module.exports = __webpack_public_path__ + "img/expenses_datail_bg_long.1739e219.png";